"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ContainsElementValidator {
    constructor(seed) {
        this.seed = seed;
    }
    isValid(input) {
        if (input) {
            for (let element of input) {
                if (element === this.seed) {
                    return true;
                }
            }
        }
        return false;
    }
}
exports.ContainsElementValidator = ContainsElementValidator;
//# sourceMappingURL=ContainsElementValidator.js.map